var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehelixDownload01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.04 19.89",
    style: {
      enableBackground: "new 0 0 19.04 19.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#180087;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#EA0020;}\n\t.st3{fill:#F66C57;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload_2_",
    transform: "translate(-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262_1_",
    transform: "translate(18.831 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707_1_",
    className: "st1",
    d: "M9.11,10.35l-2.24,3.23c-0.11,0.17-0.31,0.19-0.45,0.04c-0.01-0.01-0.02-0.03-0.03-0.04 l-2.24-3.23c-0.12-0.16-0.11-0.42,0.02-0.57c0.06-0.07,0.14-0.11,0.22-0.11h1.28V4.42c0-0.22,0.14-0.4,0.32-0.4h1.28 c0.17,0,0.32,0.18,0.32,0.4v5.26h1.28c0.17,0,0.32,0.17,0.32,0.39c0,0.1-0.03,0.2-0.08,0.28H9.11z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_264_1_",
    transform: "translate(16 8.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708_1_",
    className: "st1",
    d: "M12.98,4.02v2.43H5.94V4.02H4.67v3.23c0,0.45,0.29,0.81,0.64,0.81h8.31 c0.35,0,0.64-0.36,0.64-0.81c0,0,0,0,0,0V4.02H12.98z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehelixDownload01);
export default __webpack_public_path__ + "static/media/vehelix_download_01.403ce241.svg";
export { ForwardRef as ReactComponent };